import { Component, EventEmitter, Input, Output, ViewEncapsulation, ElementRef } from '@angular/core';
import { TrAccordionTab } from './tr-accordion-tab.component';

@Component({
    moduleId: module.id,
    selector: 'tr-accordion',
    template: `<div class="tr-accordion"
                    [ngClass]="{ 'tr-accordion--leaked': _leaked, 'tr-accordion--normal': !_leaked || !_header,
                                 'tr-accordion--top': _header,
                                 'tr-accordion--small' : _size == 'small', 'tr-accordion--large': _size != 'small',
                                 'tr-always-open' :  _minActiveTabs > 0 }">
                  <ng-content></ng-content>
              </div>`,
    styleUrls: ['tr-accordion.scss'],
    encapsulation: ViewEncapsulation.None,
    exportAs: 'TrAccordion',
})
export class TrAccordion {

    // tslint:disable:variable-name

    @Input() public get size(): string {
        return this._size || 'large';
    }

    public set size(value) {
        this._size = value;
    }

    @Input()
    get allowMultiples(): boolean { return this._allowMultiples; }
    set allowMultiples(value) { this._allowMultiples = value ? true : false; }

    @Input() public set leaked(value) {
        this._leaked = value;
    }

    @Input() public set header(value) {
        this._header = value;
    }

    @Input()
    public set minActiveTabs(value: number) {
        this._minActiveTabs = value;
    }
    public get minActiveTabs(): number {
        return this._minActiveTabs;
    }

    @Output() public close: EventEmitter<any> = new EventEmitter<any>();
    @Output() public open: EventEmitter<any> = new EventEmitter<any>();

    public _size;
    public _leaked: boolean;
    public _header: boolean;
    public _minActiveTabs: number = 0;
    public tabs: TrAccordionTab[] = [];
    private _allowMultiples: boolean;

    constructor(private elementReference: ElementRef) {}

    /** Adiciona uma tab ao accordion */
    public addTab(tab: TrAccordionTab) {
        this.tabs.push(tab);
        tab.element.nativeElement.classList.add('last-tab');

        for (const _tab of this.tabs) {
            _tab.element.nativeElement.classList.remove('last-tab');
        }
    }
}
